import { useEffect, useState } from "react";
import API from "../services/api";

export default function Permissions() {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [allPermissions, setAllPermissions] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);

    const fetchUsers = async () => {
        try {
            const res = await API.get("/users");
            setUsers(res.data);
        } catch (err) {
            alert("Unable to fetch users");
        }
    };

    const fetchAllPermissions = async () => {
        try {
            const res = await API.get("/permissions/master");
            setAllPermissions(res.data);
        } catch (err) {
            alert("Unable to fetch permissions");
        }
    };

    const fetchUserPermissions = async (userId) => {
        try {
            const res = await API.get(`/permissions/${userId}`);
            const ids = res.data.map((item) => item.id);
            setSelectedPermissions(ids);
        } catch (err) {
            alert("Unable to fetch user permissions");
        }
    };

    useEffect(() => {
        fetchUsers();
        fetchAllPermissions();
    }, []);

    const handleCheckboxChange = (permissionId) => {
        if (selectedPermissions.includes(permissionId)) {
            setSelectedPermissions(
                selectedPermissions.filter((id) => id !== permissionId)
            );
        } else {
            setSelectedPermissions([
                ...selectedPermissions,
                permissionId
            ]);
        }
    };

    const handleSavePermissions = async () => {
        if (!selectedUser) {
            alert("Please select a user");
            return;
        }

        try {
            await API.post("/permissions/save-all", {
                user_id: selectedUser,
                permissions: selectedPermissions
            });

            alert("Permissions updated successfully");

        } catch (err) {
            alert("Failed to save permissions");
        }
    };

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">
                Permission Management
            </h1>

            <div className="bg-white shadow p-6 rounded">

                <label className="block mb-2 font-semibold">
                    Select User
                </label>

                <select
                    value={selectedUser}
                    onChange={(e) => {
                        setSelectedUser(e.target.value);
                        fetchUserPermissions(e.target.value);
                    }}
                    className="border p-2 mb-6 w-full"
                >
                    <option value="">Select User</option>

                    {users.map((user) => (
                        <option key={user.id} value={user.id}>
                            {user.username} ({user.role})
                        </option>
                    ))}
                </select>

                <label className="block mb-3 font-semibold">
                    Permissions
                </label>

                <div className="grid grid-cols-2 gap-3 mb-6">
                    {allPermissions.map((permission) => (
                        <label
                            key={permission.id}
                            className="flex items-center gap-2"
                        >
                            <input
                                type="checkbox"
                                checked={selectedPermissions.includes(permission.id)}
                                onChange={() =>
                                    handleCheckboxChange(permission.id)
                                }
                            />

                            {permission.permission_name}
                        </label>
                    ))}
                </div>

                <button
                    onClick={handleSavePermissions}
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                >
                    Save Permissions
                </button>

            </div>
        </div>
    );
}